import {
  Button,
  Checkbox,
  FormControlLabel,
  Paper,
  Typography,
} from "@mui/material";
import { FormModal } from "components/ModalForm/ModalForForm";
import { useGlobalContext } from "context/GlobalContext";
import React from "react";
import { PageTitle } from "components/PageMeta/PageTitle";
import { Box } from "@mui/system";
import { updateUserPermissionApi } from "API/apis/admin/users/updateUserPermissionApi";
import { STATUS_CODES } from "constants/responses/statusCodes";
import { useUsersContext } from "../context";
import { FlexBox } from "components/Wrappers/FlexBox/FlexBox";
import { TextFieldWrapper } from "components/Wrappers/FormComponentsWrappers/TextFieldWrapper";

export const UpdateUserPermissionFormModal = ({
  title,
  openModal,
  setOpenModal,
  currentPermissionData,
  setCurrentPermissionData,
}) => {
  const { setError, setSuccess, setIsLoading } = useGlobalContext();
  const { allModules, isReloadRequired, setIsReloadRequired } =
    useUsersContext();

  const handleChange = (event) => {
    if (event.currentTarget.checked) {
      setCurrentPermissionData({
        ...currentPermissionData,
        permission: {
          ...currentPermissionData.permission,
          [event.currentTarget.value]: 1,
        },
      });
    } else {
      const temp = {
        ...currentPermissionData,
        permission: { ...currentPermissionData.permission },
      };
      delete temp.permission[event.currentTarget.value];
      setCurrentPermissionData({ ...temp });
    }
  };

  const handleChangeAccessCode = (event) => {
    setCurrentPermissionData({
      ...currentPermissionData,
      permission: {
        ...currentPermissionData.permission,
        [event.currentTarget.name]: Number(event.currentTarget.value),
      },
    });
  };
  const handleUpdateUserPermissionSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      setOpenModal(false);
      const { data, status } = await updateUserPermissionApi({
        ...currentPermissionData,
        permission: { ...currentPermissionData.permission },
      });
      if (status !== STATUS_CODES.SUCCESS) {
        throw new Error(data.message);
      }
      setSuccess(data?.message);
      setIsReloadRequired(!isReloadRequired);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error.message);
      setOpenModal(true);
    }
  };
  return (
    <Box>
      <FormModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        closeAfterTransition
      >
        <Paper
          className="formModal-class"
          sx={{
            maxHeight: "60vh",
            maxWidth: "60vw",
            overflow: "auto",
            p: 2,
          }}
        >
          <PageTitle pageName={title} />
          <form onSubmit={handleUpdateUserPermissionSubmit}>
            {allModules.map((item, index) => (
              <div key={index}>
                <Typography>{item.moduleName}</Typography>
                <Box sx={{ display: "flex", flexDirection: "column", ml: 3 }}>
                  {item.subModule.map((sub, index) => (
                    <FlexBox key={index}>
                      <FormControlLabel
                        label={sub.subModuleName}
                        control={
                          <Checkbox
                            value={sub?.subModuleAccessCode}
                            checked={
                              currentPermissionData?.permission?.[
                                sub.subModuleAccessCode
                              ] &&
                              currentPermissionData?.permission?.[
                                sub.subModuleAccessCode
                              ] > 0
                            }
                            onChange={handleChange}
                          />
                        }
                      />
                      <TextFieldWrapper
                        id="accessLevel"
                        name={sub.subModuleAccessCode}
                        label="Access Level"
                        variant="outlined"
                        value={
                          currentPermissionData?.permission?.[
                            sub.subModuleAccessCode
                          ] &&
                          currentPermissionData?.permission?.[
                            sub.subModuleAccessCode
                          ]
                        }
                        onChange={handleChangeAccessCode}
                        type="number"
                        inputProps={{ min: 1 }}
                        disabled={
                          currentPermissionData?.permission?.[
                            sub.subModuleAccessCode
                          ] &&
                          !Object.keys(
                            currentPermissionData.permission
                          ).includes(sub?.subModuleAccessCode)
                        }
                      />
                    </FlexBox>
                  ))}
                </Box>
              </div>
            ))}
            <Button variant="contained" type="submit" fullWidth>
              Update
            </Button>
          </form>
        </Paper>
      </FormModal>
    </Box>
  );
};
